import React from 'react';

const DISPLAY_DIGITS = 2;

export const Percentage: React.FC<{ percentage: number }> = ({
  percentage,
}) => {
  if (isPercentageTooHuge(percentage)) {
    return <>N/A</>;
  }

  if (isPercentageNegligible(percentage)) {
    return <>0%</>;
  }

  if (isFractionalComponentOfPercentageNegligible(percentage)) {
    return <>{percentage.toFixed(0)}%</>;
  }

  return <>{percentage.toFixed(DISPLAY_DIGITS)}%</>;
};

export const isPercentageNegligible = (percentage: number) => {
  return Math.abs(percentage) < 1 / Math.pow(10, DISPLAY_DIGITS);
};

export const isPercentageTooHuge = (percentage: number) => {
  return !Number.isFinite(percentage) || Math.abs(percentage) > 40000;
};

export const isFractionalComponentOfPercentageNegligible = (
  percentage: number,
) => {
  const fractionalComponent = percentage % 1;
  return Math.abs(fractionalComponent) < 1 / Math.pow(10, DISPLAY_DIGITS);
};
